<div class="new-stockroom-dialog">
    <div class="dialog-header">
        <div class="dialog-title-wrap">
            <h2 mat-dialog-title class="dialog-title">{{ titleText | translate }}</h2>
            <span class="dialog-required-marker">*</span>
            <span class="dialog-required-text">{{ 'Indicates required field' | translate }}</span>
        </div>
        <button type="button" class="close-btn" (click)="onClose()" aria-label="Close" [disabled]="submitting">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="dialog-header-divider"></div>

    <mat-dialog-content class="dialog-body">
        <form [formGroup]="stockroomForm" autocomplete="off">
            <div class="block request-type-block">
                <label class="mat-form-label">{{ 'request.type' | translate }}:</label>
                <mat-radio-group class="support-ticket-radio-group" formControlName="requestType"
                    (change)="onRequestTypeChange($event.value)">
                    <mat-radio-button *ngFor="let requestType of REQUEST_TYPES" [value]="requestType.value">
                        {{ requestType.label | translate }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="form-grid">
                <div class="form-field">
                    <div class="mat-form-label">{{ 'user.name' | translate }}:</div>
                    <mat-form-field class="w-100 support-ticket-field disabled-field">
                        <input matInput type="text" formControlName="requestedForUserName" />
                    </mat-form-field>
                    <small class="field-error" *ngIf="hasError('requestedForUserName', 'required')">
                        Username is required.
                    </small>
                </div>

                <div class="form-field">
                    <div class="mat-form-label">{{ 'organization.name' | translate }} <span class="req">*</span></div>
                    <mat-form-field class="w-100 support-ticket-field disabled-field">
                        <input matInput type="text" formControlName="organizationName" readonly />
                    </mat-form-field>
                    <small class="field-error" *ngIf="hasError('organizationName', 'required')">
                        {{ 'organization.name' | translate }} is required.
                    </small>
                </div>
            </div>

            <div class="form-grid" style="display: none;">
                <div class="form-field">
                    <mat-form-field appearance="outline" color="primary" class="w-100 support-ticket-field">
                        <mat-select disableOptionCentering
                            panelClass="org-stockroom-menu organization-select support-ticket-org-stockroom-menu"
                            formControlName="orgId" (selectionChange)="onOrgChange($event.value)"
                            (openedChange)="onOrgPanelOpened($event)" placeholder="{{ 'select' | translate }}">
                            <div>
                                <mat-form-field class="w-100">
                                    <mat-icon matPrefix>search</mat-icon>
                                    <input type="text" matInput
                                        placeholder="{{ 'search' | translate }} {{ 'organization' | translate }}"
                                        [value]="orgFilterText" (keydown)="$event.stopPropagation()"
                                        (input)="filterOrg($any($event.target).value)" />
                                </mat-form-field>
                            </div>
                            <div>
                                <div class="text-secondary text-center pb-3" *ngIf="!filteredOrganizations.length">
                                    <strong style="opacity: 0.5">{{ 'no.search.result' | translate }}</strong>
                                </div>
                                <mat-option *ngFor="let org of filteredOrganizations" [value]="getOrgId(org)">
                                    {{ getOrgName(org) }}
                                </mat-option>
                            </div>
                        </mat-select>
                    </mat-form-field>
                    <small class="field-error" *ngIf="hasError('orgId', 'required')">
                        {{ 'organization.name' | translate }} is required.
                    </small>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-field">
                    <div class="mat-form-label" *ngIf="stockroomForm.get('requestType')?.value !== CLONE_STOCKROOM">{{
                        'stockroom.name' | translate }} <span class="req">*</span></div>
                    <div class="mat-form-label" *ngIf="stockroomForm.get('requestType')?.value === CLONE_STOCKROOM">{{
                        'ime.clone.stockroom.name' | translate }} <span class="req">*</span></div>
                    <mat-form-field *ngIf="stockroomForm.get('requestType')?.value !== CLONE_STOCKROOM"
                        class="w-100 support-ticket-field disabled-field">
                        <input matInput type="text" formControlName="stockroomName" readonly />
                    </mat-form-field>
                    <mat-form-field *ngIf="stockroomForm.get('requestType')?.value === CLONE_STOCKROOM"
                        appearance="outline" color="primary" class="w-100 support-ticket-field">
                        <mat-select disableOptionCentering formControlName="stockroomId"
                            (selectionChange)="onStockroomChange($event.value)"
                            (openedChange)="onStockroomPanelOpened($event)" placeholder="{{ 'select' | translate }}"
                            [panelClass]="['support-ticket-select-panel', 'support-ticket-searchable-panel', 'support-ticket-org-stockroom-menu']">
                            <div class="select-search-wrap" (click)="$event.stopPropagation()">
                                <mat-icon class="select-search-icon">search</mat-icon>
                                <input class="select-search-input" type="text"
                                    placeholder="{{ 'search' | translate }} {{ 'stockroom' | translate }}"
                                    [value]="stockroomFilterText" (keydown)="$event.stopPropagation()"
                                    (input)="filterStockroom($any($event.target).value)" />
                            </div>
                            <mat-option *ngIf="loadingStockrooms" [disabled]="true">
                                {{ 'ime.loading.stockrooms' | translate }}
                            </mat-option>
                            <div *ngIf="!loadingStockrooms">
                                <div class="select-empty" *ngIf="!filteredStockrooms.length">
                                    <strong style="opacity: 0.5">{{ 'no.search.result' | translate }}</strong>
                                </div>
                                <mat-option *ngFor="let stockroom of filteredStockrooms"
                                    [value]="getStockroomId(stockroom)">
                                    {{ getStockroomName(stockroom) }}
                                </mat-option>
                            </div>
                        </mat-select>
                    </mat-form-field>
                    <small class="field-error" *ngIf="hasError('stockroomId', 'required')">
                        {{ 'stockroom.name' | translate }} is required.
                    </small>
                </div>

                <div class="form-field">
                    <div class="mat-form-label">{{ 'new.stockroom.name' | translate }} <span class="req">*</span></div>
                    <mat-form-field class="w-100 support-ticket-field">
                        <input matInput type="text" formControlName="newStockroomName" [maxlength]="STOCKROOM_NAME_MAX"
                            placeholder="{{ 'ime.enter.stockroom.name' | translate }}" (blur)="onStockroomNameBlur()" />
                    </mat-form-field>
                    <small class="field-error" *ngIf="hasError('newStockroomName', 'required')">
                        {{ 'ime.stockroom.name.is.required' | translate }}.
                    </small>
                    <small class="field-error" *ngIf="hasError('newStockroomName', 'maxlength')">
                        Maximum {{ STOCKROOM_NAME_MAX }} characters allowed.
                    </small>
                    <small class="field-error" *ngIf="hasError('newStockroomName', 'duplicate')">
                        {{ 'alert.stockroom.already.exists' | translate }}.
                    </small>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-field" *ngIf="stockroomForm.get('requestType')?.value !== CLONE_STOCKROOM">
                    <div class="mat-form-label">{{ 'active.user.access' | translate }}:</div>
                    <mat-form-field appearance="outline" color="primary" class="w-100 support-ticket-field">
                        <mat-select disableOptionCentering
                            panelClass="support-ticket-select-panel user-access-select-panel"
                            formControlName="userAccessSelection" (selectionChange)="onUserAccessSelected($event.value)"
                            (openedChange)="onUserAccessPanelOpened($event)" placeholder="{{ 'select' | translate }}">
                            <div class="user-access-search-wrap">
                                <mat-form-field class="w-100 user-access-search-field">
                                    <mat-icon matPrefix>search</mat-icon>
                                    <input type="text" matInput
                                        placeholder="{{ 'search' | translate }} {{ 'users' | translate }}"
                                        [value]="userAccessFilterText" (keydown)="$event.stopPropagation()"
                                        (input)="filterUserAccess($any($event.target).value)" />
                                </mat-form-field>
                            </div>
                            <div>
                                <div class="text-secondary text-center pb-3" *ngIf="!filteredActiveUsers.length">
                                    <strong style="opacity: 0.5">{{ 'no.search.result' | translate }}</strong>
                                </div>
                                <mat-option *ngFor="let user of filteredActiveUsers" [value]="user.userIdValue"
                                    [disabled]="isUserAccessSelected(user.userIdValue)">
                                    {{ user.displayName }}
                                </mat-option>
                            </div>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-field">
                    <div class="mat-form-label">{{ 'ship.to.number' | translate }} <span class="req">*</span></div>
                    <div class="ship-to-row">
                        <mat-form-field class="w-100 support-ticket-field">
                            <mat-select formControlName="shipToNumber" (selectionChange)="onShipToChange($event.value)">
                                <mat-option *ngFor="let shipTo of shipTos" [value]="shipTo">{{ shipTo }}</mat-option>
                                <mat-option [value]="SHIP_TO_CUSTOM_VALUE">{{ 'other' | translate }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <small class="field-error" *ngIf="hasError('shipToNumber', 'required')">
                        {{ 'ship.to.number' | translate }} is required.
                    </small>

                    <div class="custom-shipto-wrap" *ngIf="customShipTo">
                        <mat-form-field class="w-100 support-ticket-field">
                            <input matInput formControlName="customShipToNumber"
                                placeholder="{{ 'enter.ship.to.number' | translate }}" />
                        </mat-form-field>
                        <small class="field-error" *ngIf="hasError('customShipToNumber', 'required')">
                            {{ 'ship.to.number' | translate }} is required.
                        </small>
                    </div>
                </div>
            </div>

            <section class="user-access-selection-table"
                *ngIf="stockroomForm.get('requestType')?.value !== CLONE_STOCKROOM">
                <div class="mat-form-label">{{ 'ime.user.access.selection' | translate }}</div>
                <div class="user-access-table-wrap">
                    <table class="user-access-table">
                        <thead>
                            <tr>
                                <th>{{ 'user.name' | translate }}</th>
                                <th>{{ 'email' | translate }}</th>
                                <th class="action-column">{{ 'action' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let user of selectedUserAccessUsers">
                                <td>{{ getActiveUserName(user) }}</td>
                                <td>{{ getActiveUserEmail(user) || '-' }}</td>
                                <td class="action-column">
                                    <button type="button" class="row-delete-btn"
                                        (click)="removeUserAccess(user.userIdValue)"
                                        aria-label="Remove user access selection">
                                        <mat-icon>delete_outline</mat-icon>
                                    </button>
                                </td>
                            </tr>
                            <tr *ngIf="!selectedUserAccessUsers.length">
                                <td colspan="3" class="empty-selection">
                                    {{ 'No user access selections added.' | translate }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <div class="block" *ngIf="showStockroomModeSection">
                <label class="mat-form-label">{{ 'stockroom.mode' | translate }}:</label>
                <mat-radio-group class="support-ticket-radio-group" formControlName="stockroomMode"
                    (change)="onStockroomModeChange($event.value)">
                    <mat-radio-button *ngFor="let mode of STOCKROOM_MODES" [value]="mode.value">
                        {{ mode.label | translate }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <section class="master-stockroom-panel"
                *ngIf="stockroomForm.get('stockroomMode')?.value === STOCKROOM_MODE_POU">
                <h3>{{ 'ime.list.of.stockroom' | translate }}</h3>
                <div class="form-field">
                    <div class="mat-form-label">{{ 'ime.enter.master.to.tie' | translate }} <span class="req">*</span>
                    </div>
                    <mat-form-field appearance="outline" color="primary" class="w-100 support-ticket-field">
                        <mat-select disableOptionCentering panelClass="support-ticket-select-panel"
                            formControlName="masterStockroomId" placeholder="{{ 'select' | translate }}">
                            <mat-option *ngIf="loadingMasterStockrooms" [disabled]="true">
                                {{ 'ime.loading.stockrooms' | translate }}
                            </mat-option>
                            <mat-option *ngIf="!loadingMasterStockrooms && !masterStockrooms.length" [disabled]="true">
                                {{ 'ime.no.stockrooms.found' | translate }}
                            </mat-option>
                            <mat-option *ngFor="let stockroom of masterStockrooms"
                                [value]="getMasterStockroomId(stockroom)">
                                {{ getMasterStockroomName(stockroom) }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <small class="field-error" *ngIf="hasError('masterStockroomId', 'required')">
                        {{ 'ime.master.stockroom.is.required' | translate }}.
                    </small>
                </div>
            </section>

            <div class="block">
                <div class="mat-form-label">{{ 'comments' | translate }}:</div>
                <mat-form-field class="w-100 support-ticket-field support-ticket-textarea">
                    <textarea matInput formControlName="comments" rows="4"
                        placeholder="{{ 'Enter your valuable comments...' | translate }}"></textarea>
                </mat-form-field>
                <small class="field-error" *ngIf="hasError('comments', 'maxWords')">
                    Maximum {{ COMMENT_MAX_WORDS }} words allowed.
                </small>
            </div>
        </form>
    </mat-dialog-content>

    <div class="dialog-footer">
        <button type="button" class="cancel-btn" (click)="onClose()" [disabled]="submitting">{{ 'cancel' | translate
            }}</button>
        <button type="button" class="submit-btn" (click)="submit()" [disabled]="submitting || validatingName">
            <span *ngIf="!submitting">{{ 'submit' | translate }}</span>
            <mat-spinner *ngIf="submitting" diameter="18" class="submit-spinner"></mat-spinner>
        </button>
    </div>
</div>